<header class="db-connect-only__header">
  <div class="header-title">
    <div class="texts">
      <span class="db-center"><img src="assets/images/logos/10web_name_logo_dark.svg" /></span>
    </div>
  </div>
  <a (click)="signOut.emit()" [innerHTML]="'text_sideBarLogOut' | dbText"></a>
</header>

<div class="db-connect-only">
  <div>
    <p class="db-connect-only__title"><span [innerHTML]="'text_addWebsiteWelcome' | dbText"></span>
      <img src="assets/images/emojis/grinning_face_with_star_eyes.png" alt=""/></p>
    <p class="db-connect-only__title bold" [innerHTML]="'text_addWebsiteHeaderPremiumPlugin' | dbText"></p>
    <div class="db-connect-only__card-wrap">
      <div class="db-connect-only__card">
        <img src="assets/images/premium-plugins-logos/{{premiumPlugin?.slug + (premiumPlugin?.slug === Config.optimizerPluginSlug ? '.png' : '.svg')}}" alt="" *ngIf="premiumPlugin"/>
        <b *ngIf="premiumPlugin" [innerHTML]="premiumPlugin?.slug === Config.optimizerPluginSlug ? ('text_addWebsitePremiumPluginStep1Speed' | dbText) : 'text_addWebsitePremiumPluginStep1' | dbText : {premiumPlugin: premiumPlugin?.title}"></b>
        <img src="assets/images/premium-plugins-logos/bundle.svg" alt="" *ngIf="!premiumPlugin"/>
        <b *ngIf="!premiumPlugin" [innerHTML]="'text_addWebsitePremiumPluginStep1Bundle' | dbText"></b>
      </div>

      <div class="db-connect-only__card">
        <img src="assets/images/premium-plugin/premium-plugin-step-1.png" alt=""/>
        <b [innerHTML]="'text_addWebsitePremiumPluginStep2' | dbText"></b>
      </div>

      <div class="db-connect-only__card db-connect-only__card-speed-3step" *ngIf="premiumPlugin?.slug === Config.optimizerPluginSlug">
        <b [innerHTML]="'text_addWebsitePremiumPluginStep3' | dbText"></b>
      </div>
    </div>
    <div class="db-connect-only__content">

      <div>
        <div class="db-connect-only__content-item">
          <i class="db-icon db-icon-ds-circle-filled"></i>
          <div>{{'text_ltd_connect_website_popup_step1' | dbText}}
            <a class="ds-btn-blue" href="{{managerLink}}" download
               (click)="download.emit()">
              <span class="db-ab-test-link" [innerHTML]="'text_addWebsiteManuallyStep1Title' | dbText"></span>
            </a>
          </div>
        </div>
        <div class="db-connect-only__content-item">
          <i class="db-icon db-icon-ds-circle-filled"></i> {{'text_installActivatePluginWP' | dbText}}
        </div>
      </div>
      <img class="db-connect-only__connect-img" src="assets/images/migration/copy_website.png" alt=""/>
    </div>

  </div>
</div>
